module.exports = __webpack_public_path__ + "img/one1.205eabd9.jpg";